import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useWagmiAuth } from 'app/providers';
import { packagesModel } from 'entities/mine-package';
import { selectIsOwnedPackage } from 'entities/mine-package/model';
import { paymentModel } from 'entities/payment';
import { selectCurrentPayment } from 'entities/payment/model';
import { Tap2MineReferralFormProvider } from 'features/tap2mine-referral';
import { Spinner, StepperConsumer, useAppDispatch, useShallowSelector } from 'shared';

import { STEPPER_ROUTES } from './lib/stepper';
import { Background, BackgroundCard } from './ui/shared';
import { Stepper } from './buy-package.constants';
import { resolveInitialStep, useInitWidgetData } from './lib';

const StepperAccessGuard = () => {
  const dispatch = useAppDispatch();
  const { state } = useWagmiAuth();

  useEffect(() => {
    if (!state.isAuthorized) {
      dispatch(paymentModel.actions.clearUserPaymentState());
      dispatch(packagesModel.actions.clearOwnedPackage());
    }
  }, [dispatch, state.isAuthorized]);

  return (
    <StepperConsumer>
      {({ replace, step }) => {
        if (!state.isAuthorized && step !== STEPPER_ROUTES.PAYMENT_INITIAL) {
          // setTimeout helps to get rid of this error:
          // "Can't perform a React state update on an unmounted component"
          setTimeout(() => replace(STEPPER_ROUTES.PAYMENT_INITIAL), 0);
        }
        return null;
      }}
    </StepperConsumer>
  );
};

const LoadingView = () => {
  return (
    <BackgroundCard sx={{ justifyContent: 'center', aspectRatio: '4/5' }}>
      <Spinner />
    </BackgroundCard>
  );
};

export const BuyPackage = () => {
  const { isLoading } = useInitWidgetData();

  const isOwnedNft = useShallowSelector(selectIsOwnedPackage);
  const currentPayment = useShallowSelector(selectCurrentPayment);

  if (isLoading) {
    return <LoadingView />;
  }

  return (
    <Tap2MineReferralFormProvider>
      <Stepper.Provider initialStep={resolveInitialStep(currentPayment, isOwnedNft)}>
        <StepperAccessGuard />
      </Stepper.Provider>
    </Tap2MineReferralFormProvider>
  );
};

export const BuyPackageView = () => {
  return (
    <Box component="section" pt={{ xs: 8, sm: 17.5 }} mb={8.5}>
      <BuyPackage />
      <Background />
    </Box>
  );
};
